import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getShopperAgentCapabilities = {
  name: "getShopperAgentCapabilities" as const,
  // Most capabilities are team-level, but discounts resolve per conversation.
  input: z.object({ teamId: zExt.objectId(), conversationId: zExt.objectId() }),
  output: z.object({
    // Every capability is returned; the client decides how to present the
    // unavailable ones.
    capabilities: z.array(
      z.object({
        kind: z.string(),
        available: z.boolean(),
        warning: z.string().optional(),
      }),
    ),
  }),
};
